import { Component } from '@mycolorway/tao';
import { MDCMenuSurfaceFoundation, MDCMenuSurface, Corner } from '@material/menu-surface';
import Sortable from 'sortablejs';
import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/projects/todo-field-sequences.scss';

Component('tr-project-todo-field-sequences', {
  mixins: [eventListenerMixin],

  properties: {
    openOnReady: {
      type: Boolean,
      default: true,
    },

    submitUrl: String,
  },

  ready() {
    this.initMenuSurface();
    this.initSortable();

    this.listenTo(
      this.querySelector('.menu-surface-anchor'),
      'click', () => this.toggleOpen(),
    );

    this.listenTo(this.mdcMenuSurface, {
      'MDCMenuSurface:opened': () => {
        this.initialFieldSequences = this.getFieldSequences();
      },
      'MDCMenuSurface:closed': this.handleMenuSurfaceClosed.bind(this),
    });
  },

  initMenuSurface() {
    this.menuSurfaceRoot = this.querySelector('.mdc-menu-surface');
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurfaceRoot);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);
    this.mdcMenuSurface.setMenuSurfaceAnchorElement(this);

    // eslint-disable-next-line no-underscore-dangle
    this.mdcMenuSurface
      .foundation_.handleBodyClick = function handleBodyClick(event) {
        if (!closest(event.target, 'body > .wrapper')) return;
        MDCMenuSurfaceFoundation.prototype.handleBodyClick.call(this, event);
      };

    if (this.openOnReady) {
      this.toggleOpen(true);
      this.openOnReady = false;
    }
  },

  initSortable() {
    this.sortable = Sortable.create(this.querySelector('.todo-fields'), {
      animation: 0,
      draggable: '.todo-field-item',
      handle: '.sortable-handle',
      onChoose: () => this.classList.add('sorting'),
      onUnchoose: () => this.classList.remove('sorting'),
      onEnd: () => this.classList.remove('sorting'),
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
    });
  },

  toggleOpen(open = !this.mdcMenuSurface.open) {
    this.mdcMenuSurface.open = open;
  },

  handleMenuSurfaceClosed() {
    const fieldSequences = this.getFieldSequences();

    const fieldIds = fieldSequences.map(f => f.todoFieldId).join(',');
    const initialFieldIds = this
      .initialFieldSequences.map(f => f.todoFieldId).join(',');

    const fieldStatuses = fieldSequences.map(f => f.enabled).join(',');
    const initialFieldStatuses = this
      .initialFieldSequences.map(f => f.enabled).join(',');

    const changed = fieldIds !== initialFieldIds || fieldStatuses !== initialFieldStatuses
      || fieldSequences.some(f => f.changed);
    if (changed) {
      $.ajax({
        url: this.submitUrl,
        method: 'post',
        data: {
          projects: {
            todo_field_sequences: fieldSequences.map(field => (
              { todo_field_id: field.todoFieldId, enabled: field.enabled }
            )),
          },
        },
        dataType: 'script',
      });
    }
  },

  getFieldSequences() {
    return Array.from(
      this.querySelectorAll('.todo-fields .todo-field-item'),
    ).map((item) => {
      const { todoFieldId, changed } = item.dataset;
      const { checked: enabled } = item.querySelector('tr-switch-field');
      return { todoFieldId, enabled, changed: changed === 'true' };
    });
  },

  disconnected() {
    this.stopListening();
    if (this.sortable) this.sortable.destroy();
    if (this.mdcMenuSurface) this.mdcMenuSurface.destroy();
  },
});
